import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const token = this.authService.token();
    const user = this.authService.user();

    let authenticated = !!token && !!user;

    if (!!authenticated === false) {
      this.router.navigate(['login']);
    }

    if (route.url[0].path === 'reports' && user.role !== 'admin') {
      authenticated = false;
      this.router.navigate(['/']);
    }

    return authenticated;
  }

}
